export const SUPPORTS_OBJECT_GET_OWN_PROPERTY_DESCRIPTOR = "getOwnPropertyDescriptor" in Object;
